<div class="flex gap-1 h-full scroll-general-y">
  <div class="w-[calc(100%-2.5rem)]!">
    @if (quotationId == 0) {
      <app-page-general
        class="w-full"
        [idPage]="15"
        [quotationId]="quotationId"
        [starNgOnInit]="true"
        [tollArray]="tollArray"
      ></app-page-general>
    }
    @if (quotationId != 0 && quotationId != null) {
      <div class="flex justify-end">
        <button
          (click)="setQuotationId(0)"
          class="bg-(--brand-azul-primario)! text-white! text-base! text-center rounded-2xl w-50"
          matButton="filled"
        >
          {{ 'quotation.fieldNames.newQuotation' | translate }}
        </button>
      </div>
      <app-page-general
        class="w-full"
        [idPage]="4"
        [quotationId]="quotationId"
        [starNgOnInit]="true"
        [tollArray]="tollArray"
      ></app-page-general>
    }
  </div>

  <div class="sticky top-0 z-50 w-6">
    <div
      class="flex justify-center items-center relative transition-all duration-500 ease-in-out z-40"
      [ngClass]="isExpanded ? '-left-58! ' : 'left-0! '"
    >
      <div
        class="rounded-xl bg-white general-shadow-r-none w-6 h-30 relative left-1 flex justify-center items-center cursor-pointer"
        (click)="isExpanded = !isExpanded"
      >
        <mat-icon class="text-(--comp-icon-color-primary)! p-1">{{
          isExpanded ? 'arrow_forward_ios' : 'arrow_back_ios'
        }}</mat-icon>
      </div>

      <div class="h-[calc(100vh-4.6rem)] flex justify-center items-center">
        <div
          class="h-full flex-col flex items-baseline overflow-hidden whitespace-nowrap transition-all duration-500 ease-in-out general-simple-box"
          [ngClass]="isExpanded ? 'w-135! py-10 gap-4' : 'w-0! '"
        >
          <div class="flex flex-col gap-4 scroll-general-y px-4">
            <div class="text-general-title text-(--color-text-primary) flex gap-5 items-center">
              <div class="bg-(--comp-gray-bg) size-10 rounded-xl flex items-center justify-center">
                <mat-icon>edit_note</mat-icon>
              </div>

              {{ 'quotation.titles.quotationsInProcess' | translate }}
            </div>

            <div class="flex gap-1">
              <app-input-general
                class="w-full"
                [formControlGeneral]="searchControl"
                [label]="'general.search'"
                [placeholder]="'general.search'"
              ></app-input-general>
            </div>

            @for (card of this.dataSource.filteredData; track card) {
              <div class="general-simple-box-light w-120! flex gap-1 p-2">
                <div class="flex flex-col gap-1 justify-center items-start w-120">
                  <div class="text-(--color-text-gray) text-sm">{{ card.quotationId }}</div>
                  <div class="text-(--color-text-gray) text-sm">
                    {{ card.vehicleDescription }}
                  </div>
                  <div
                    class="text-(--color-text-primary) text-sm wrap-break-word whitespace-normal w-full"
                  >
                    {{ card.vehicleType }}
                  </div>
                </div>

                <div class="flex gap-1 justify-center items-center w-22">
                  <button
                    (click)="setQuotationId(card.quotationId)"
                    class="cursor-pointer bg-(--comp-gray-bg) size-10 rounded-xl flex items-center justify-center text-(--color-text-secondary)"
                  >
                    <mat-icon [matTooltip]="'general.select' | translate">web_traffic</mat-icon>
                  </button>
                  <button
                    (click)="openModalCancelQuotation(card.quotationId)"
                    class="cursor-pointer bg-(--comp-gray-bg) size-10 rounded-xl flex items-center justify-center text-(--color-text-error)"
                  >
                    <mat-icon [matTooltip]="'general.delete' | translate">delete</mat-icon>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
